export const USER_TYPE_OPTIONS = [
    { value: 'CTR', label: 'Contractor' },
    { value: 'MIL', label: 'Military' },
    { value: 'CIV', label: 'Civilian' },
];

export const USER_TYPE_CODES = USER_TYPE_OPTIONS.map((option) => option.value);

export const USER_TYPE_LABELS = USER_TYPE_OPTIONS.reduce((accumulator, option) => {
    accumulator[option.value] = option.label;
    return accumulator;
}, {});

export const normalizeUserTypeCode = (value) => {
    const normalizedValue = String(value ?? '').trim().toUpperCase();
    return USER_TYPE_CODES.includes(normalizedValue) ? normalizedValue : '';
};

export const getUserTypeDisplayLabel = (value, fallback = '') => {
    const normalizedCode = normalizeUserTypeCode(value);
    if (normalizedCode) {
        return USER_TYPE_LABELS[normalizedCode] ?? fallback;
    }

    const rawValue = String(value ?? '').trim();
    return rawValue || fallback;
};
